import '../style/dashboard/ADS.css';

const ADS =({img,title,subtitle})=>{
  return(
    <div className="ads">
      <img src={img} alt="ads-img" />
      <div className="ads-info">
        <div className="ads-badge">ADS</div>
        <div className="ads-info-title">{title}</div>
        <div className="ads-info-subtitle">{subtitle}</div>
      </div>
    </div>
  )
}

export default ADS;